import React, { useCallback, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { getValidFields } from '../../../helpers/form.new';
import { EventType } from '../../../helpers/analytics';
import { extendFormData } from '../../../store/reducers/formStore';
import { StepContext } from '../creator/step.context';
import { useAnalytics } from '../../hooks/analytics';
import { FORM_FIELDS, FORM_FIELDS_LABELS_CONFIG } from '../../../constants';
import { isSatisfyOption } from '../../../helpers';

const notRequiredFields = [
    FORM_FIELDS.AUTO_BRAND,
    FORM_FIELDS.AUTO_MODEL,
    FORM_FIELDS.AUTO_YEAR,
    FORM_FIELDS.NUMBER_OF_DEPENDENTS,
    FORM_FIELDS.SNILS,
    FORM_FIELDS.ADDITIONAL_INCOME,
    FORM_FIELDS.RENT_APARTMENT,
    FORM_FIELDS.PROPERTY_TYPE,
    FORM_FIELDS.CAR,
    FORM_FIELDS.EMPLOYER_INN,
    FORM_FIELDS.OKVED,
];

export const useFormOnBlur = (form: UseFormReturn, sendAnalytics = true): React.FocusEventHandler<HTMLFormElement> => {
    const dispatch = useDispatch();
    const { analyticStepText } = useContext(StepContext);
    const { pushEvent } = useAnalytics();
    const { trigger } = form;

    return useCallback(
        async (event) => {
            const { name: fieldName } = event.target;
            if (!fieldName) {
                return;
            }
            await trigger(fieldName);
            const validFields = getValidFields(form);

            if (Object.keys(validFields).includes(fieldName)) {
                dispatch(extendFormData(validFields));
            }

            if (!sendAnalytics) {
                return;
            }

            const fieldLabel = FORM_FIELDS_LABELS_CONFIG[fieldName]?.text || fieldName;

            const requireLabel = isSatisfyOption(notRequiredFields, fieldName) ? 'Необязательное' : 'Обязательное';

            if ({}.hasOwnProperty.call(validFields, fieldName)) {
                const isParameter = isSatisfyOption(
                    [FORM_FIELDS.AMOUNT, FORM_FIELDS.PURPOSE, FORM_FIELDS.PERIOD, FORM_FIELDS.AGREEMENT],
                    fieldName,
                );

                if (isParameter) {
                    pushEvent({
                        event: EventType.mainEvent,
                        eventAction: 'Изменение параметра',
                        eventLabel: [`${analyticStepText}`, fieldLabel].join('|'),
                    });
                } else {
                    pushEvent({
                        event: EventType.mainEvent,
                        eventAction: 'Заполнение поля',
                        eventLabel: [`${analyticStepText}`, fieldLabel, requireLabel].join('|'),
                    });
                }
            } else {
                pushEvent({
                    event: EventType.mainEvent,
                    eventAction: 'Ошибка заполнения поля',
                    eventLabel: [`${analyticStepText}`, fieldLabel, 'Ошибка валидации', requireLabel].join('|'),
                });
            }
        },
        [sendAnalytics, form, dispatch, trigger, analyticStepText, pushEvent],
    );
};
